
<!--footer-->
<div class="spring-break_footer">
  <a href="https://www.gbarena.com" target="_blank" class="gbarena">
    <img src="assets/img/GBarena-type.svg" style="width: 80px" alt="GBarena Logo">
  </a>
  <p>Spring Break event is hosted and powered by GBarena <br> All Terms & Conditions Apply </p>
  <span>
    <a href="https://facebook.com/gbarena" target="_blank"><i class="icon-facebook-circled"></i></a>
    <a href="https://twitter.com/gbarenaofficial" target="_blank"><i class="icon-twitter-circled"></i></a>
    <i class="icon-discord"></i>
  </span>
</div>